import Skeleton from '../../Skeleton';

import { Container } from './styles';

const LoadingUser: React.FC<React.PropsWithChildren<unknown>> = () => {
  return (
    <Container>
      <div className="row">
        <Skeleton className="row-skeleton name" />
      </div>
    </Container>
  );
};

export default LoadingUser;
